import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function Users() {


  const headers = {
    token: localStorage.getItem("userToken"),
  };

  const [UserData, setUserData] = useState([]);

  async function getUserData() {
    try {
      const response = await axios.get(
        `https://vehex-production.up.railway.app/user/allUsers`
      );
      console.log(response.data.users);
      
      setUserData(response.data.users);
    } catch (error) {
      console.error("Error fetching Users data:", error);
    }
  }

  async function deleteUserData(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/user/deleteUser/${id}`,
            { headers }
          );
          console.log(response);
          

          if (response.data.message === "User deleted successfully") {
            Swal.fire({
              title: "The User has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            getUserData();

          }
        } catch (error) {
          console.error("Error deleting User:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the User.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }

  useEffect(() => {
    getUserData();
  }, []);
  return (
    <div className=" overflow-x-auto">
    <table className=" table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {UserData.map((userData) => (
          <tr key={userData._id}>
            <td>
              {userData?.name}
            </td>
            <td>
            {userData?.email}
            </td>
            <td>
            {userData?.mobile}
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => deleteUserData(userData._id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  )
}
